export default __webpack_public_path__ + "dist/media/Comment.f7eb181c.svg";